import React from 'react';
import { AppBar, Toolbar, Box, Typography, IconButton, useMediaQuery, useTheme, Menu, MenuItem } from "@mui/material";
import { useNavigate } from 'react-router-dom';
import LogoutIcon from '@mui/icons-material/Logout';
// Full-colour logo for the light header
import TechwaveLogo from '../Assets/imgs/logo.png';
import { createTheme, ThemeProvider } from "@mui/material/styles";
import Tooltip from '@mui/material/Tooltip';
import '../Assets/css/Navbar.css';
import Avatar from '@mui/material/Avatar';
const Navbar = ({ handleLogout, isAuthenticated, username,selectedModel,isAdminAuthenticated }) => {
  const navigate = useNavigate();
  const theme = useTheme();
  const isXsScreen = useMediaQuery(theme.breakpoints.down('xs'));
  const isSmScreen = useMediaQuery(theme.breakpoints.down('sm'));
  const isMdScreen = useMediaQuery(theme.breakpoints.down('md'));

  const [anchorEl, setAnchorEl] = React.useState(null);
  const [mobileMoreAnchorEl, setMobileMoreAnchorEl] = React.useState(null);

  const capitalizeFullName = (fullname) => {
    const parts = fullname.split(' ');
    if (parts.length === 1 && fullname.length > 15) {
      return fullname.slice(0, 15);
    }
    const firstPart = parts[0].charAt(0).toUpperCase() + parts[0].slice(1).toLowerCase();
    return firstPart;
  };



  const getLogoSize = () => {
    if (isXsScreen) return { width: '96px', height: 'auto' };
    if (isSmScreen) return { width: '112px', height: 'auto' };
    return { width: '132px', height: 'auto' };
  };

  const getTechwaveLogoSize = () => {
    if (isXsScreen) return '16px';
    if (isSmScreen) return '18px';
    return '20px';
  };
  const theme1 = createTheme({
    components: {
      MuiTooltip: {
        styleOverrides: {
          tooltip: {
            fontSize: "12px",
            fontFamily: "Kumbh Sans, sans-serif",
          },
        },
      },
    },
  });
  const getTypographyVariant = () => {
    if (isXsScreen) return 'caption';
    if (isSmScreen) return 'body2';
    return 'body1';
  };

  const formattedName = capitalizeFullName(username);

  const handleProfileMenuOpen = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleMobileMenuClose = () => {
    setMobileMoreAnchorEl(null);
  };

  const handleMenuClose = () => {
    setAnchorEl(null);
    handleMobileMenuClose();
  };

  const handleMobileMenuOpen = (event) => {
    setMobileMoreAnchorEl(event.currentTarget);
  };

  // const handleLogoutClick = () => {
  //   handleMenuClose();
  //   handleLogout();
  // };

  const handleLogoutClick = () => {
  handleMenuClose();
  handleLogout();
  if (isAdminAuthenticated) {
    navigate('/internal/admin_login');
  } else {
    navigate('/');
  }
};

  const menuId = 'primary-search-account-menu';
  const renderMenu = (
    <Menu
      anchorEl={anchorEl}
      anchorOrigin={{
        vertical: 'bottom',
        horizontal: 'right',
      }}
      id={menuId}
      keepMounted
      transformOrigin={{
        vertical: 'top',
        horizontal: 'right',
      }}
      open={Boolean(anchorEl)}
      onClose={handleMenuClose}
      sx={{ 
        zIndex: 9999, // Extremely high z-index to ensure it's on top
        '& .MuiPaper-root': {
          zIndex: 9999, // Ensure the menu's paper component is also on top
          position: 'fixed', // Use fixed positioning to take it out of normal document flow
          mt: 1,ml:1.5
        }
      }}
      PaperProps={{
        style: {
          zIndex: 9999, // Additional z-index on PaperProps
        }
      }}
      PopoverClasses={{
        root: 'navbar-menu-root', // Add a custom class for additional styling if needed
      }}
    >
      <MenuItem sx={{ justifyContent: 'flex-start', pointerEvents: "none" }} >
        <strong style={{ fontSize: '15px', fontFamily:'Kumbh sans'}}>{username}</strong>
      </MenuItem>
      <MenuItem onClick={handleLogoutClick} sx={{ justifyContent: 'flex-start' }}>
        <LogoutIcon sx={{ mr: 1, fontSize: '1rem' }} />
        <strong style={{ fontSize: '15px', fontFamily:'Kumbh sans' }}>Logout</strong>
      </MenuItem>
    </Menu>
  );
  

  const mobileMenuId = 'primary-search-account-menu-mobile';
  const renderMobileMenu = (
    <Menu
      anchorEl={mobileMoreAnchorEl}
      anchorOrigin={{
        vertical: 'bottom',
        horizontal: 'right',
      }}
      id={mobileMenuId}
      keepMounted
      transformOrigin={{
        vertical: 'top',
        horizontal: 'right',
      }}
      open={Boolean(mobileMoreAnchorEl)}
      onClose={handleMobileMenuClose}
      sx={{ 
        zIndex: 9999, // Extremely high z-index to ensure it's on top
        '& .MuiPaper-root': {
          zIndex: 9999, // Ensure the menu's paper component is also on top
          position: 'fixed', // Use fixed positioning to take it out of normal document flow
          mt: 1.5,ml:1.5
        }
      }}
      PaperProps={{
        style: {
          zIndex: 9999, // Additional z-index on PaperProps
        }
      }}
      PopoverClasses={{
        root: 'navbar-menu-root', // Add a custom class for additional styling if needed
      }}
    >
      <MenuItem sx={{ justifyContent: 'flex-start', padding: '4px 8px', minHeight: '30px', pointerEvents: "none" }}>
        <strong style={{ fontSize: '12px', fontFamily:'Kumbh sans' }}>{username}</strong>
      </MenuItem>
      <MenuItem onClick={handleLogoutClick} sx={{ justifyContent: 'flex-start', padding: '4px 8px', minHeight: '30px' }}>
        <LogoutIcon sx={{ mr: 1, fontSize: '1rem' }} />
        <strong style={{ fontSize: '12px', fontFamily:'Kumbh sans' }}>Logout</strong>
      </MenuItem>
    </Menu>
  );
  
  const stringAvatar = (name) => {
    const nameParts = name.split(' ');
    const initials = nameParts.map(part => part[0].toUpperCase()).join('').slice(0, 2); // Get first 2 initials
    return {
      sx: {
        background: 'linear-gradient(135deg, #6a4cff, #a07cf7)',
        color: 'white',     // White font color
        width: 36,
        height: 36,
        marginRight: 1,
        fontFamily: 'Kumbh Sans',
        fontSize: '0.85rem',
        fontWeight: 700,
        boxShadow: '0 2px 8px rgba(106, 76, 255, 0.35)',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
      },
      children: initials,
    };
  };
  const handleLogoClick = () => {

    if (isAdminAuthenticated) {
      // ✅ Redirect admin to admin dashboard
      navigate('/internal/admin_dashboard');
      return;
    }

    localStorage.removeItem('selectedAssociations');
    localStorage.removeItem('selectedYears');
    localStorage.removeItem('selectedMetrics');
    navigate('/home'); // only user landing page in this app
  };
  return (
    <AppBar className='appbar-css'>
      <Toolbar>
        <Box sx={{ display: 'flex', alignItems: 'center' }}>
        <img
  src={TechwaveLogo}
  className="techwavelogo-css"
  alt="Techwave Logo"
  style={{ 
    ...getLogoSize(),
    cursor: "pointer"
  }}
  onClick={handleLogoClick} 
/>

        </Box>
        <Box
          sx={{
            position: 'absolute',
            left: '50%',
            transform: 'translateX(-50%)',
            display: 'flex',
            alignItems: 'center',
          }}
        >
          <div className="navbar-title" style={{ fontSize: getTechwaveLogoSize() }}>
            Cloud Migration Factory
            <span className="navbar-badge">AI</span>
          </div>
        </Box>
        
        {isAuthenticated && username && (
          <Box sx={{ marginLeft: 'auto', display: 'flex', alignItems: 'center' }}>
            <Box sx={{ display: { xs: 'none', md: 'flex' } }}>
<ThemeProvider theme={theme1}>
<IconButton
  size="large"
  edge="end"
  aria-label="account of current user"
  aria-controls={menuId}
  aria-haspopup="true"
  onClick={handleProfileMenuOpen}
  color="inherit"
>
  <Tooltip 
    title={username} 
    placement="top" 
    PopperProps={{
      modifiers: [
        {
          name: "preventOverflow",
          options: { boundary: "window" },
        },
        {
          name: "offset",
          options: { offset: [0, -10] }, // Moves tooltip closer to avatar
        },
      ],
      style: {
        zIndex: 9999, // Extremely high z-index to ensure it's on top
      }
    }}
    sx={{
      zIndex: 9999, // Additional z-index styling
      '& .MuiTooltip-tooltip': {
        zIndex: 9999, // Target the actual tooltip element
      }
    }}
  >
    <Avatar {...stringAvatar(username)} />
  </Tooltip>
</IconButton>
</ThemeProvider>
            </Box>
            <Box sx={{ display: { xs: 'flex', md: 'none' } }}>
              <IconButton
                size="small" // Changed from "large" to "small"
                aria-label="show more"
                aria-controls={mobileMenuId}
                aria-haspopup="true"
                onClick={handleMobileMenuOpen}
                color="inherit"
                sx={{ padding: { xs: '4px', sm: '8px' } }} // Reduced padding on extra small screens
              >
                 <Avatar {...stringAvatar(username)} fontSize="medium"/>
                
                </IconButton>
            </Box>
          </Box>
        )}
      </Toolbar>
      {renderMobileMenu}
      {renderMenu}
    </AppBar>
  );
};

export default Navbar;